import { render } from "./card-detail.vue?vue&type=template&id=72aaa94b&scoped=true"
import script from "./card-detail.vue?vue&type=script&lang=js"
export * from "./card-detail.vue?vue&type=script&lang=js"

import "./card-detail.vue?vue&type=style&index=0&id=72aaa94b&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72aaa94b"]])

export default __exports__